
let Drawers = function () {

    let selectors = {
        drawerTrigger: document.querySelectorAll('[data-drawer-trigger]'),
        mobileMenu: document.querySelectorAll('[data-mobile-menu]'),
        search: document.querySelector('[data-search-form]'),
        siteDrawers: document.querySelectorAll('.drawer')
    }


    let checkSearch = function (){
        
        if( selectors.search.classList.contains('is--active')){
            selectors.search.classList.add('is--active')
        };
    };

    let scrollingNavHide = function () {

        let scrollingNav = document.querySelector('[data-scrolling-nav]');

        if(scrollingNav){
            let scrollingNavParent = scrollingNav.parentElement;

            if( scrollingNav.innerHTML.length > 0 && window.getComputedStyle(scrollingNavParent).display == 'block' ){
                scrollingNav.style.display = "none";
            }
        }
    };

    let scrollingNavShow = function () {

        let scrollingNav = document.querySelector('[data-scrolling-nav]');
        if(scrollingNav){
            let scrollingNavParent = scrollingNav.parentElement;

            if( scrollingNav.innerHTML.length > 0 && window.getComputedStyle(scrollingNavParent).display == 'none' ){
                scrollingNav.style.display = "block";
            }
        }
    };

    let closeTarget = function ( target ){
        
        if( document.querySelector(target).classList.contains('is--active') ){
            
            scrollingNavShow();
            document.querySelector('body').classList.remove('no--scroll');
            document.querySelector(target).classList.remove('is--active');
            if(target === '[data-mini-cart]') {
                document.querySelector(target).removeAttribute('open');
                document.querySelector('.cart-mini-container').classList.remove('cart-mini-container--open');
            }

            document.dispatchEvent(new Event("drawer:close", [document.querySelector(target)]));
        }
    };

    var openTarget = function ( target ){
        // is open
        if (document.querySelector(target).classList.contains('is--active') == false) {
             // Check if the scrolling nav is active and hide it
             scrollingNavHide();

             // Set the top position of the drawer
            // setTop(target);

            // Add Classes
            document.querySelector(target).classList.add('is--active');

            // Trigger the drawer open event
            document.dispatchEvent(new Event("drawer:open", [document.querySelector(target)]));
        }
    };

    var toggleTarget = function (target){

        // is open
        if( document.querySelector(target).classList.contains('is--active') ){
            // Run the close drawer function on target
            closeTarget(target);

        // is closed
        }else{

            // check if the search is active
            checkSearch();

            // Run the open drawer function on target
            openTarget(target);
            
        }
    };
    
    selectors.drawerTrigger.forEach(trigger => {
        trigger.addEventListener("click", function (e){
            e.preventDefault();
            
            let target = '['+this.dataset.target+']';
    
            toggleTarget(target);
        }); 
    });

    // document.addEventListener('drawer:open', function (event, drawer) {
    //     if( drawer.classList.contains('mobile-menu') ){
    //         document.querySelector('[data-target="data-mobile-menu"]').classList.add('is--active');
    //     }
    // });

    // // needed to remove active class to mobile menu trigger
    // document.addEventListener('drawer:close', function (event, drawer) {
    //     if( drawer.classList.contains('mobile-menu') ){
            
    //         document.querySelector('[data-target="data-mobile-menu"]').classList.remove('is--active');
    //     }
    // });

    document.addEventListener('keyup', function(e) {
        if(e.key == 'Escape'){

            selectors.siteDrawers.forEach((drawer) => {
                if(drawer.classList.contains('is--active')){
                    drawer.classList.remove('is--active');
                    document.body.classList.remove('no--scroll');
                }
            });
        }
    });

    if(document.querySelector('[data-mini-cart-notes-trigger]')){
        document.querySelector('[data-mini-cart-notes-trigger]').addEventListener('click', (e) => {
            document.querySelector('[data-mini-cart-notes]').classList.toggle('is--visible');
        })
    }

}();